import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import AdministratorDetailForm from '../../Components/Content/Administrators/AdministratorDetailForm';

const EditAdministratorPage: React.FC = () => {
    const { userId } = useParams<{ userId: string }>();
    const navigate = useNavigate();

    return (
        <AdministratorDetailForm
            editUserId={userId}
            onSuccess={() => navigate(`/Admin/Users/Administrators/${userId}`)}
            onCancel={() => navigate(-1)}
        />
    );
};

export default EditAdministratorPage;
